import { render, staticRenderFns } from "./polybasicShengXue.vue?vue&type=template&id=d50427be&scoped=true&"
import script from "./polybasicShengXue.vue?vue&type=script&lang=js&"
export * from "./polybasicShengXue.vue?vue&type=script&lang=js&"
import style0 from "./polybasicShengXue.vue?vue&type=style&index=0&id=d50427be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50427be",
  null
  
)

export default component.exports